export const RIDER_EVENTS = {
  RIDE_CREATED: 'ride:created',
  RIDE_UPDATED: 'ride:updated',
  RIDE_STATUS_CHANGED: 'ride:status_changed',
  RIDE_DRIVER_ASSIGNED: 'ride:driver_assigned',
  RIDE_DRIVER_REJECTED: 'ride:driver_rejected',
  RIDE_DRIVER_ARRIVED: 'ride:driver_arrived',
  RIDE_STARTED: 'ride:started',
  RIDE_COMPLETED: 'ride:completed',
  RIDE_CANCELLED: 'ride:cancelled',
  RIDE_LOCATION_UPDATED: 'ride:location_updated',
  DRIVER_LOCATION_UPDATED: 'driver:location_updated',
  CURRENT_RIDE: 'current_ride',
  NO_DRIVERS_AVAILABLE: 'no_drivers_available',
} as const;

export type RiderEventType = typeof RIDER_EVENTS[keyof typeof RIDER_EVENTS];

